export default __webpack_public_path__ + "static/media/icon-html.81ab74bb.svg";